module.exports = __webpack_public_path__ + "img/user-attribute-orange.d3801ebd.svg";